import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { IconModule } from '../icon';
import { ButtonComponent } from './button.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    IconModule
  ],
  declarations: [
    ButtonComponent
  ],
  exports: [
    ButtonComponent
  ]
})
export class ButtonModule { }
